module.exports = __webpack_public_path__ + "img/jp-info.c4c806bc.png";